












import Vue from "vue";
import Component from "vue-class-component";
import { Emit, Prop } from "vue-property-decorator";
import { CandidateService } from "@/services/Public";
import JobsSelectDialog from "./JobsSelectDialog.vue";

@Component({
  name: "SaveDialog",
  components: {
    JobsSelectDialog,
  },
})
export default class extends Vue {
  @Prop({ required: true, default: [] })
  public readonly jobs!: [];

  @Prop({ required: true, default: "" })
  public readonly candidateId!: string;

  @Prop({ required: false, default: false })
  public readonly value!: boolean;

  private loading = false;

  async onActionClick(selectedJobs: string[]) {
    try {
      this.loading = true;
      await CandidateService.save(this.candidateId, selectedJobs);
      this.successSave();
      this.input(false);
    } catch (e) {
      console.log("Save candidate error: ", e);
    } finally {
      this.loading = false;
    }
  }

  @Emit()
  input(value: boolean) {
    return value;
  }

  @Emit()
  successSave() {
    return true;
  }
}
